import React from "react";
import IconNotes from "@/components/icons/IconNotes";
import IconSaveVideo from "@/components/icons/IconSaveVideo";
import IconDocs from "@/components/icons/IconDocs";
import IconCalender from "@/components/icons/IconCalender";
import IconSopTask from "@/components/icons/IconSopTask";
import IconChat from "@/components/icons/IconChat";
import IconList from "@/components/icons/IconList";
import IconConnections from "@/components/icons/IconConnections";
import { Col, Row } from "antd";
import ButtonComponent from "@/components/button/Button";
import { useDispatch, useSelector } from "react-redux";
import { getIsGuidePanel } from "@/reducers/guideSlice";
import { useNavigate } from "react-router-dom";
import "@/styles/components/resourses.scss";
import { setIsMiniDashboardOpen } from "@/reducers/commonSlice";
import { IconBlog } from "../icons/others/icons";
const resource = [
  {
    name: "My Students",
    path: "/myStudents",
    isGuide: true,
    isStudent: false,
    isDisabled: false,
    icon: <IconConnections color="#fdfefe" />,
  },
  {
    name: "My Sessions",
    path: "/sessions",
    isGuide: true,
    isStudent: false,
    isDisabled: false,
    icon: <IconList color="#fdfefe" />,
  },
  {
    name: "Conversations",
    path: "/dashboard/conversations",
    isGuide: true,
    isStudent: true,
    isDisabled: false,
    icon: <IconChat color="#fdfefe" />,
  },
  {
    name: "Tasks",
    path: "/dashboard/tasks",
    isGuide: true,
    isStudent: true,
    isDisabled: false,
    icon: <IconSopTask color="#fdfefe" />,
  },
  {
    name: "My Availability",
    path: "/availability",
    isGuide: true,
    isStudent: false,
    isDisabled: false,
    icon: <IconCalender color="#fdfefe" />,
  },
  {
    name: "Documents",
    path: "/dashboard/documents",
    isGuide: true,
    isStudent: true,
    isDisabled: false,
    icon: <IconDocs color="#fdfefe" />,
  },
  {
    name: "Saved Video",
    path: "/saved-video",
    isGuide: true,
    isStudent: true,
    isDisabled: false,
    icon: <IconSaveVideo color="#fdfefe" />,
  },
  {
    name: "My Notes",
    path: "/notes",
    isGuide: true,
    isStudent: false,
    isDisabled: false,
    icon: <IconNotes color="#fdfefe" />,
  },

  // IconBlog blog
  {
    name: "Blogs",
    path: "/dashboard/my-blogs",
    isGuide: true,
    isStudent: false,
    isDisabled: false,
    icon: <IconBlog color="#fdfefe" />,
  }

  // {
  //   name: "Blogs",
  //   path: "/dashboard",
  //   isGuide: true,
  //   isStudent: true,
  //   isDisabled: true,
  //   icon: <IconBlog color="#fdfefe" />,
  // },
];
const Resources = ({ isDrawer = false }) => {
  const isGuidePanel = useSelector(getIsGuidePanel);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleNavigate = (path) => {
    dispatch(setIsMiniDashboardOpen(false));
    navigate(path);
  };
  return (
    <div>
      <Row gutter={[16, 16]}>
        {resource
          .filter((x) => (isGuidePanel ? x.isGuide : x.isStudent))
          .map((x, i) => {
            return (
              <Col
                key={i}
                xxl={isDrawer ? 12 : 6}
                xl={isDrawer ? 12 : 6}
                lg={isDrawer ? 12 : 6}
                md={6}
                sm={24}
                xs={24}
              >
                <ButtonComponent
                  label={x.name}
                  varient="dark"
                  icon={x.icon}
                  className={x.isDisabled ? "button-disable" : ""}
                  onClick={() => !x.isDisabled && handleNavigate(x.path)}
                ></ButtonComponent>
              </Col>
            );
          })}
      </Row>
    </div>
  );
};

export default Resources;
